import './LoginSection.css';
import loginImage from '../../img/login-image.svg';
import { Link, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const LoginSection = () => {

    const [usernameInput, setUsernameInput] = useState("");
    const [passwordInput, setPasswordInput] = useState("");
    const history = useHistory();

    const handleLoginButton = (e) => {
        if (usernameInput == "" || passwordInput == "") {
            Swal.fire({
                title: "Mohon isi email dan password dengan benar.",
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1000
            });
        } else {
            e.preventDefault();
            console.log(usernameInput, passwordInput)
            const data = JSON.stringify({
                email: usernameInput,
                password: passwordInput
            });

            fetch("https://backend-markopedia.herokuapp.com/api/login", {
                method: "POST",
                body: data,
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            }).then(res => {
                res.json().then(res => {
                    if (res.status === "OK") {
                        console.log(res);
                        localStorage.setItem("sessionId", res.sessionId)
                        localStorage.setItem("userId", res.id)
                        localStorage.setItem("userFullName", res.fullName)
                        localStorage.setItem("userAddress", res.address)
                        localStorage.setItem("userEmailAddress", res.emailAddress)
                        localStorage.setItem("userMobilePhone", res.mobilePhone)
                        Swal.fire({
                            title: "Login berhasil.",
                            icon: "success",
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        });

                        history.push("/")
                    } else {
                        Swal.fire({
                            title: "Login gagal. Periksa kembali akun Anda.",
                            icon: "error",
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        });
                    }
                });
            })


        }
    }

    const handleUsernameChange = (e) => {
        setUsernameInput(e.target.value);
    }

    const handlePasswordChange = (e) => {
        setPasswordInput(e.target.value);
    }


    return (
        <div className="loginsection-wrapper">
            <img className="loginsection-image" src={loginImage}></img>
            <div className="loginsection-input">
                <div className="loginsection-input-username">
                    <h4>Email</h4>
                    <input onChange={handleUsernameChange} id="usernameInput" type="email" placeholder="Masukkan email"></input>
                </div>
                <div className="loginsection-input-password">
                    <h4>Password</h4>
                    <input onChange={handlePasswordChange} id="passwordInput" type="password" placeholder="Masukkan password"></input>
                </div>
                <div className="loginsection-input-loginbtn">
                    <button onClick={handleLoginButton} className="login-btn" id="loginButton" >Login</button>
                </div>
                <div className="loginsection-input-registersign">
                    <h4>Belum punya akun? Daftar
                        <span> </span>
                        <Link className="loginsection-input-registersign-registerbtn" to="/register">
                            <span>di sini</span>
                        </Link>
                        .
                    </h4>
                </div>
            </div>
        </div>
    )
};

export default LoginSection;